import React from 'react'
import IconWrapper, { IconProps } from './IconWrapper'

export const AmazonIcon = (props: IconProps) => (
    <IconWrapper {...props}>
        <svg
            version="1.1"
            x="0px"
            y="0px"
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            enableBackground="new 0 0 24 24"
            xmlSpace="preserve"
            aria-hidden="true"
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M19.975 16.669c.432-.11 1.434-.284 1.86-.193q.9.078 1.08.29c.254.366-.126 1.65-.3 2.068-.153.368-.87 1.55-1.24 1.55-.113 0-.199-.08-.14-.23 1.36-3.08.752-3-1.26-2.83-.26.03-1.212.215-1.1 0 0-.256.837-.59 1.1-.655m-9.48-5.602q0 .752.39 1.203c.744.862 2.101.4 2.67-.625.314-.523.64-1.545.64-2.87-1.1 0-1.45.053-1.85.156-1.173.32-1.85 1.033-1.85 2.136m-3.439.386c0-1.804 1-3.069 2.54-3.696 1.36-.558 3.238-.711 4.599-.79 0-1.586-.223-2.85-1.94-2.85-.55 0-1.535.594-1.76 1.584-.053.256-.186.441-.4.48l-2.3-.252c-.278-.064-.386-.212-.32-.468C7.94 3.123 9.96 2.125 12.255 2c1.1 0 2.764-.014 4.06 1.136 1.402 1.35 1.18 3.05 1.18 7.45 0 1.057.016 1.158.76 2.098.15.216.163.421-.055.578l-1.802 1.501q-.24.173-.582.038c-.984-.812-.748-.763-1.36-1.5-1.242 1.301-2.218 1.655-3.88 1.655-1.975 0-3.52-1.187-3.52-3.503m-5.7 5.465q5 2.793 10.88 2.793 3.919-.001 7.739-1.406c.386-.148.793-.437 1.03-.116q.17.232-.11.424c-2.468 1.715-5.906 2.637-8.9 2.637-4.236 0-8.004-1.513-10.878-4.004-.257-.204-.052-.505.24-.328"
                clipRule="evenodd"
            ></path>
        </svg>
    </IconWrapper>
)
